import { render, staticRenderFns } from "./samecityChildlist.vue?vue&type=template&id=23e9a133&scoped=true"
import script from "./samecityChildlist.vue?vue&type=script&lang=js"
export * from "./samecityChildlist.vue?vue&type=script&lang=js"
import style0 from "./samecityChildlist.vue?vue&type=style&index=0&id=23e9a133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9a133",
  null
  
)

export default component.exports